export default __webpack_public_path__ + "static/media/sandcastle.63ec920e.png";